
<div
  :class="classes(n())"
  role="listbox"
  :aria-label="`Column ${columnIndex}`"
  :aria-activedescendant="activeDescendantId"
>
  <div
    ref="scrollRef"
    :class="n('scroll')"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
    @touchcancel="onTouchEnd"
  >
    <div
      :class="n('options')"
      :style="wrapperStyle"
    >
      <div
        v-for="(option, index) in options"
        :id="`picker-col-${columnIndex}-opt-${index}`"
        :key="getOptionValue(option)"
        :class="classes(
          n('option'),
          {
            [n('option--selected')]: index === currentIndex,
            [n('option--disabled')]: isOptionDisabled(option),
          },
          option.className
        )"
        role="option"
        :aria-selected="index === currentIndex ? 'true' : 'false'"
        :aria-disabled="isOptionDisabled(option) ? 'true' : undefined"
        @click="handleClickOption(option, index)"
      >
        <slot
          name="option"
          :option="option"
          :index="index"
          :column-index="columnIndex"
        >
          <span :class="n('option-text')">{{ getOptionText(option) }}</span>
        </slot>
      </div>
    </div>
  </div>
</div>
